import React, { Component, Fragment } from 'react';
import Card from './../../homePage/planCardContainer';
import cx from 'classnames';
import styles from './../../../styles/homePage/card.scss';
import { getPlanCards } from '../../../utils/planCard';

interface TopPlanCardsProps {
  sections: any[];
  buckets: any[];
  url?: any;
}

class TopPlanCards extends Component<TopPlanCardsProps> {
  private static handleBtnScroll(e: any) {
    const scrollAmount = 310;
    const { btn } = e.currentTarget.dataset;
    const el = document.getElementById('top-plan-cards-row');
    el.scroll({
      left: el.scrollLeft + (btn === 'left' ? -scrollAmount : scrollAmount),
      behavior: 'smooth',
    });
  }

  public render() {
    const { sections, buckets, url } = this.props;

    const cards = getPlanCards(sections, buckets);

    return (
      <Fragment>
        <div className={cx(styles['top-plan-cards'])}>
          <div className={'mb10'}>
            <h2 className={'font--dark-grey text--xxlg mb0'}>Top Plans</h2>
            <p
              className={
                'text--lg font--grey mobile-only--text--xmd desktop-only line-height__1blKI'
              }
            >
              Investment Plans Handpicked by Experts to achieve your goals
            </p>
          </div>
          <div className={cx('b30', 'relative')}>
            <div
              id="top-plan-cards-row"
              className={cx(styles['top-plan-cards-row'])}
            >
              {cards &&
                cards.map((card) => (
                  <Card
                    data={card.data}
                    id={'top-plans'}
                    hideHighlights={false}
                    hideBenifits={false}
                    hideSpacer={false}
                    minHeight={false}
                    key={card.data.bucketId}
                    url={url}
                  />
                ))}
            </div>
            <button
              onClick={TopPlanCards.handleBtnScroll}
              type="button"
              data-btn="left"
              className={cx(styles['btn-arrow'], styles['left'])}
            >
              <img
                src={
                  'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1556106664_arrow-left-circle-shadow.svg'
                }
              />
            </button>
            <button
              onClick={TopPlanCards.handleBtnScroll}
              type="button"
              data-btn="right"
              className={cx(styles['btn-arrow'], styles['right'])}
            >
              <img
                src={
                  'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1556106664_arrow-left-circle-shadow.svg'
                }
              />
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default TopPlanCards;



// WEBPACK FOOTER //
// ./components/homePage/experimental/topPlanCards.tsx